import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useTaskFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      projectTasks: [],
      projectTaskStatuses: [],
      projectTaskRecordStatusId: null,
      projectTaskTags: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const taskSearchParamsConfig = useMemo(
    () => ({
      projectTasks: searchParamsConfig.projectTasks,
      projectTaskStatuses: searchParamsConfig.projectTaskStatuses,
      projectTaskRecordStatusId: searchParamsConfig.projectTaskRecordStatusId,
      projectTaskTags: searchParamsConfig.projectTaskTags,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback(
    (filters) => ({
      projectTaskId: filters.projectTasks?.map((v) => v.id),
      projectTaskStatusId: filters.projectTaskStatuses?.map((v) => v.id),
      projectTaskRecordStatusId: filters.projectTaskRecordStatusId ?? undefined,
      projectTaskTagId: filters.projectTaskTags?.map((v) => v.id),
    }),
    [],
  );

  const mapClickThroughParams = useCallback(
    (filters) => ({
      projectTaskId: filters.projectTasks?.map((v) => v.id),
      projectTaskStatusId: filters.projectTaskStatuses?.map((v) => v.id),
      projectTaskRecordStatusId: filters.projectTaskRecordStatusId ?? undefined,
      projectTaskTagId: filters.projectTaskTags?.map((v) => v.id),
    }),
    [],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: taskSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams }),
    [filters, taskSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams],
  );
}
